export const ImportFilesPage = [
  {
    path: "/importFlie",
    component: () => import("@/views/import/ImportFile"),
  },
  {
    path: "/importCommonItems",
    component: () => import("@/views/import/importCommonItems"),
  },
  {
    path: "/importBoms",
    component: () => import("@/views/import/ImportBOM"),
  },
  {
    path: "/importRelationship",
    component: () => import("@/views/import/importRelationship"),
  },
  {
    path: "/importMfrp",
    component: () => import("@/views/import/importMfrp"),
  },
  {
    path: "/importBomsNew",
    component: () => import("@/views/import/ImportBOMsNew"),
  },
  {
    path: "/importBOMsByLevel",
    component: () => import("@/views/import/ImportBOMsByLevel"),
  },

  {
    path: "/importBOMsByLevelNew",
    component: () => import("@/views/import/importCommonBOMByLevel"),
  },
  {
    path: "/importCommonTaskRecords",
    component: () => import("@/views/import/ImportProjectRecord"),
  },

  {
    path: "/drawingImport",
    component: () => import("@/views/import/drawingImport/index.vue"),
  },
];
